var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.373 3.8055C14.885 3.8055 14.462 4.4655 14.462 5.9205V8.322H18.4198L18.0298 12.2123H14.4613V24H9.72503V12.2115H6.53003V8.32125H9.72653V5.98725C9.72653 2.0625 11.3 0 15.7138 0C16.661 0 17.7943 0.075 18.4708 0.1695V3.822",
    fill: "#0060FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fb-logo.1ad6d4e90ca8a5de67ca7389b7b61801.svg";
export { ForwardRef as ReactComponent };